import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { IdBuilder } from "../ts/rlAdmin.utils";

export function RLMessage() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/message.html"),
        scope: {},
        bindToController: {
            error: '='
        },
        transclude: true,
        controllerAs: "mVM",
        controller: RLMessageController
    };
    return directive;
}

class RLMessageController {
    error: Models.IDbValidationError;
    static $inject = ["$scope"];
    constructor($scope: ng.IScope) {
    }

    getEntityCharTypeName() {
        return Consts.CharTypeNames.IDs[IdBuilder.splitEntityID(this.error.entityId).charTypeID];
    }

    getEntityPluralCharTypeName() {
        return Consts.PluralCharTypeNames.IDs[IdBuilder.splitEntityID(this.error.entityId).charTypeID];
    }

    getChildEntityCharTypeName() {
        return Consts.CharTypeNames.IDs[this.error.childCharTypeId];
    }

    getChildEntityPluralCharTypeName() {
        return Consts.PluralCharTypeNames.IDs[this.error.childCharTypeId];
    }
}